import { compact } from '@direct-frontend/stdlib';
import { BaseFilter, InferFilterItemFromFilter } from '../../types/Filters';

/**
 * Приводит список элементов фильтрации к строке.
 * Работает только для фильтров со строчными значениями – с массивом строк или одиночной строкой (или энамов).
 * Подходит для фильтров на гридах, так как они преобразуются к строке для использования в query
 * @param filterItems - массив FilterItem для преобразования в строку
 * @typeParam FilterType - тип фильтра, подмножество фильтров со строковыми значениями
 * @returns массив FilterItem
 * @kind helper
 */
export function stringifyFilterItems<FilterType extends BaseFilter>(
    filterItems: InferFilterItemFromFilter<FilterType>[]
): string {
    return compact(
        filterItems.map(item => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- filterId подтип строки
            const { filterId, subFilterId, operator = '=', value } = item;

            const filterDescription = [filterId, subFilterId].filter(Boolean).join('.');
            const valueString = (Array.isArray(value) ? value : [value])
                .filter(Boolean)
                .map(String)
                .map(valueItem => valueItem.replace(/\\/g, '\\\\').replace(/\|/g, '\\|').replace(/,/g, '\\,'))
                .join(',');

            if (!valueString) {
                return null;
            }

            return [filterDescription, operator, valueString].join(' ');
        })
    ).join('|');
}
